/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Model imports.
*/
import { Ratings } from '../../onboarding/interface/global.model';

@Component({
  selector: 'app-input-choice-grid',
  templateUrl: './input-choice-grid.component.html',
  styleUrls: ['./input-choice-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputChoiceGridComponent implements OnInit {

  /**
   * Receive the ratings array.
   * Number of rows to show.
   * Number of columns to show.
   */
  @Input() values: Ratings;
  @Input() name: string;
  @Input() rows = [];
  @Input() columns = [];
  @Input() isViewMode: boolean;
  @Input() prefilled = [];
  @Input() datePickerClass = 'form-control';
  @Input() isDisabled;



  /**
   * Send selected rating outside.
   */
  @Output() emitSelected: EventEmitter<{ row: { code: number }; column: number; subColIndx:number; value:any; rowIndx:number }> = new EventEmitter();

  public ratings: Ratings;

  public componentPlacement = 'auto';

  ngOnInit(): void {
    this.ratings = JSON.parse(JSON.stringify(this.values));
  }

  /**
   * Receive the selected rating and send selected.
   */
  setRating(rowIndex: number, columnIndex: number): void {
    if (!this.checkIsViewMode()) {
      this.sendSelected(rowIndex, columnIndex);
    }
  }

  /**
   * Send selected rating outside.
   */
  sendSelected(rowIndex: number, columnIndex: number): void {
  //  this.emitSelected.emit({ row: this.rows[rowIndex], column: columnIndex });
  }

  checkIsViewMode(): boolean {
    return this.isViewMode;
  }

  /**
   * Track the indexed stream.
   */
  trackById(index, ques): void {
    return ques ? ques.id : undefined;
  }
  /**
   * Track the indexed stream.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  trackByIndex(index, ques): void {
    return index;
  }

  getSelected(index: number, id: string): boolean {
    return this.prefilled?.length ? (this.prefilled.some(val => (index === (Number(val?.textValue) - 1) && id === val?.optionCode))) : false;
  }

  getPrefilledValue(row, coloum, subCloumn): string {
    return '';
  }
  getValueFromResponse(code: string, colIndex: number, subColIndex: number): string | null {
    const rowIndex = this.prefilled.findIndex(value => value.optionCode === code);
    if (rowIndex >= 0 && rowIndex < this.prefilled.length) {
      const rowData = this.prefilled[rowIndex];
      // Find the matching igi entry based on cpos (column index) and scpos (sub-column index)
      const igiEntry = rowData.igi.find(igi => igi.cpos === colIndex && igi.scpos === subColIndex);
      // If the matching igi entry exists, return the value; otherwise return undefined
      if (igiEntry) {
        return igiEntry.val;
      }
    }
  
    // Return undefined if no value is found
    return null;
  }
  
  /**
   * Check if date is valid or not.
   */
  isValidDate(date: Date): boolean {
    return date instanceof Date && !isNaN(date?.valueOf());
  }
  onDateChange(e,subColIndx, colIndx, rowIndx): void {
    if (this.isValidDate(e?.Date) && e?.Date != undefined) {
      this.emitSelected.emit({ row: this.rows[rowIndx], column: colIndx, subColIndx, value:e.Date, rowIndx });
    }
  }

  keyup(value, subColIndx, colIndx, rowIndx): void {
    if (value?.length > 0 ) {
          this.emitSelected.emit({ row: this.rows[rowIndx], column: colIndx, subColIndx, value, rowIndx });
    }
  }

  public error_msg = null;
  public default_start_date;
  public minDate: Date = new Date('01/01/2007');
  //public maxDate: Date = new Date();
  public setDate(dateObj): void {
    this.error_msg = null;



  }
}
